"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Site extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.organisation = null;
        this.objectTypeName = 'site';
        this._name = initParams.name;
        this._groupTypeId = initParams.group_type_id;
        this._timezone = initParams.timezone;
        this._dataTypes = (0, util_1.camelArray)(initParams.data_types);
        this._organisationId = initParams.organisation_id;
        this._tariffIds = (0, util_1.camelArray)(initParams.tariff_ids);
        this._address = initParams.address;
        this._totalDemand = initParams.total_demand;
        this._widgetBoardId = initParams.widget_board_id;
        this._locationId = initParams.location_id;
        this._locationName = initParams.location_name;
        this._lat = initParams.lat;
        this._lng = initParams.lng;
        this._locationMetadata = initParams.location_metadata;
        this.__permission = initParams._permission;
        this._gateways = (0, util_1.camelArray)(initParams.gateways);
        this._issues = initParams.issues;
        this._issueIds = (0, util_1.camelArray)(initParams.issue_ids);
        this._customFields = (0, util_1.camelArray)(initParams.custom_fields);
        this._deviceList = (0, util_1.camelArray)(initParams.device_list);
        this._occupancyScheduleId = initParams.occupancy_schedule_id;
        this._occupancyScheduleName = initParams.occupancy_schedule_name;
        this._occupancySchedule = (0, util_1.camelArray)(initParams.occupancy_schedule);
        this._defaultOccupancyScheduleId = initParams.default_occupancy_schedule_id;
        this._defaultOccupancyScheduleName = initParams.default_occupancy_schedule_name;
        this._defaultOccupancySchedule = (0, util_1.camelArray)(initParams.default_occupancy_schedule);
        this._disconnectedAssetsViaHub = initParams.disconnected_assets_via_hub;
        this._lowBatteryAssets = initParams.low_battery_assets;
        this._appliances = initParams.appliances;
        this._lowSignalAssets = initParams.low_signal_assets;
        this._assetsWithIssues = initParams.assets_with_issues;
        this._faultyAssets = initParams.faulty_assets;
        this._intermittentAssets = initParams.intermittent_assets;
        this._anomalousAssets = initParams.anomalous_assets;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateSite(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set groupTypeId(value) {
        console.error('Do not set objects this way');
    }
    setGroupTypeId(value) {
        return this.dataService.updateSite(this.id, { group_type_id: value }, this);
    }
    get groupTypeId() {
        return this._groupTypeId;
    }
    set timezone(value) {
        console.error('Do not set objects this way');
    }
    setTimezone(value) {
        return this.dataService.updateSite(this.id, { timezone: value }, this);
    }
    get timezone() {
        return this._timezone;
    }
    set dataTypes(value) {
        console.error('Do not set objects this way');
    }
    setDataTypes(value) {
        return this.dataService.updateSite(this.id, { data_types: (0, util_1.snakeArray)(value) }, this);
    }
    get dataTypes() {
        return this._dataTypes;
    }
    set organisationId(value) {
        console.error('Do not set objects this way');
    }
    setOrganisationId(value) {
        return this.dataService.updateSite(this.id, { organisation_id: value }, this);
    }
    get organisationId() {
        return this._organisationId;
    }
    set tariffIds(value) {
        console.error('Do not set objects this way');
    }
    setTariffIds(value) {
        return this.dataService.updateSite(this.id, { tariff_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get tariffIds() {
        return this._tariffIds;
    }
    set address(value) {
        console.error('Do not set objects this way');
    }
    setAddress(value) {
        return this.dataService.updateSite(this.id, { address: value }, this);
    }
    get address() {
        return this._address;
    }
    set totalDemand(value) {
        console.error('Do not set objects this way');
    }
    setTotalDemand(value) {
        return this.dataService.updateSite(this.id, { total_demand: value }, this);
    }
    get totalDemand() {
        return this._totalDemand;
    }
    set widgetBoardId(value) {
        console.error('Do not set objects this way');
    }
    setWidgetBoardId(value) {
        return this.dataService.updateSite(this.id, { widget_board_id: value }, this);
    }
    get widgetBoardId() {
        return this._widgetBoardId;
    }
    set locationId(value) {
        console.error('Do not set objects this way');
    }
    setLocationId(value) {
        return this.dataService.updateSite(this.id, { location_id: value }, this);
    }
    get locationId() {
        return this._locationId;
    }
    set locationName(value) {
        console.error('Do not set objects this way');
    }
    setLocationName(value) {
        return this.dataService.updateSite(this.id, { location_name: value }, this);
    }
    get locationName() {
        return this._locationName;
    }
    set lat(value) {
        console.error('Do not set objects this way');
    }
    setLat(value) {
        return this.dataService.updateSite(this.id, { lat: value }, this);
    }
    get lat() {
        return this._lat;
    }
    set lng(value) {
        console.error('Do not set objects this way');
    }
    setLng(value) {
        return this.dataService.updateSite(this.id, { lng: value }, this);
    }
    get lng() {
        return this._lng;
    }
    set locationMetadata(value) {
        console.error('Do not set objects this way');
    }
    setLocationMetadata(value) {
        return this.dataService.updateSite(this.id, { location_metadata: value }, this);
    }
    get locationMetadata() {
        return this._locationMetadata;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateSite(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set gateways(value) {
        console.error('Do not set objects this way');
    }
    setGateways(value) {
        return this.dataService.updateSite(this.id, { gateways: (0, util_1.snakeArray)(value) }, this);
    }
    get gateways() {
        return this._gateways;
    }
    set issues(value) {
        console.error('Do not set objects this way');
    }
    setIssues(value) {
        return this.dataService.updateSite(this.id, { issues: value }, this);
    }
    get issues() {
        return this._issues;
    }
    set issueIds(value) {
        console.error('Do not set objects this way');
    }
    setIssueIds(value) {
        return this.dataService.updateSite(this.id, { issue_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get issueIds() {
        return this._issueIds;
    }
    set customFields(value) {
        console.error('Do not set objects this way');
    }
    setCustomFields(value) {
        return this.dataService.updateSite(this.id, { custom_fields: (0, util_1.snakeArray)(value) }, this);
    }
    get customFields() {
        return this._customFields;
    }
    set deviceList(value) {
        console.error('Do not set objects this way');
    }
    setDeviceList(value) {
        return this.dataService.updateSite(this.id, { device_list: (0, util_1.snakeArray)(value) }, this);
    }
    get deviceList() {
        return this._deviceList;
    }
    set occupancyScheduleId(value) {
        console.error('Do not set objects this way');
    }
    setOccupancyScheduleId(value) {
        return this.dataService.updateSite(this.id, { occupancy_schedule_id: value }, this);
    }
    get occupancyScheduleId() {
        return this._occupancyScheduleId;
    }
    set occupancyScheduleName(value) {
        console.error('Do not set objects this way');
    }
    setOccupancyScheduleName(value) {
        return this.dataService.updateSite(this.id, { occupancy_schedule_name: value }, this);
    }
    get occupancyScheduleName() {
        return this._occupancyScheduleName;
    }
    set occupancySchedule(value) {
        console.error('Do not set objects this way');
    }
    setOccupancySchedule(value) {
        return this.dataService.updateSite(this.id, { occupancy_schedule: (0, util_1.snakeArray)(value) }, this);
    }
    get occupancySchedule() {
        return this._occupancySchedule;
    }
    set defaultOccupancyScheduleId(value) {
        console.error('Do not set objects this way');
    }
    setDefaultOccupancyScheduleId(value) {
        return this.dataService.updateSite(this.id, { default_occupancy_schedule_id: value }, this);
    }
    get defaultOccupancyScheduleId() {
        return this._defaultOccupancyScheduleId;
    }
    set defaultOccupancyScheduleName(value) {
        console.error('Do not set objects this way');
    }
    setDefaultOccupancyScheduleName(value) {
        return this.dataService.updateSite(this.id, { default_occupancy_schedule_name: value }, this);
    }
    get defaultOccupancyScheduleName() {
        return this._defaultOccupancyScheduleName;
    }
    set defaultOccupancySchedule(value) {
        console.error('Do not set objects this way');
    }
    setDefaultOccupancySchedule(value) {
        return this.dataService.updateSite(this.id, { default_occupancy_schedule: (0, util_1.snakeArray)(value) }, this);
    }
    get defaultOccupancySchedule() {
        return this._defaultOccupancySchedule;
    }
    set disconnectedAssetsViaHub(value) {
        console.error('Do not set objects this way');
    }
    setDisconnectedAssetsViaHub(value) {
        return this.dataService.updateSite(this.id, { disconnected_assets_via_hub: value }, this);
    }
    get disconnectedAssetsViaHub() {
        return this._disconnectedAssetsViaHub;
    }
    set lowBatteryAssets(value) {
        console.error('Do not set objects this way');
    }
    setLowBatteryAssets(value) {
        return this.dataService.updateSite(this.id, { low_battery_assets: value }, this);
    }
    get lowBatteryAssets() {
        return this._lowBatteryAssets;
    }
    set appliances(value) {
        console.error('Do not set objects this way');
    }
    setAppliances(value) {
        return this.dataService.updateSite(this.id, { appliances: value }, this);
    }
    get appliances() {
        return this._appliances;
    }
    set lowSignalAssets(value) {
        console.error('Do not set objects this way');
    }
    setLowSignalAssets(value) {
        return this.dataService.updateSite(this.id, { low_signal_assets: value }, this);
    }
    get lowSignalAssets() {
        return this._lowSignalAssets;
    }
    set assetsWithIssues(value) {
        console.error('Do not set objects this way');
    }
    setAssetsWithIssues(value) {
        return this.dataService.updateSite(this.id, { assets_with_issues: value }, this);
    }
    get assetsWithIssues() {
        return this._assetsWithIssues;
    }
    set faultyAssets(value) {
        console.error('Do not set objects this way');
    }
    setFaultyAssets(value) {
        return this.dataService.updateSite(this.id, { faulty_assets: value }, this);
    }
    get faultyAssets() {
        return this._faultyAssets;
    }
    set intermittentAssets(value) {
        console.error('Do not set objects this way');
    }
    setIntermittentAssets(value) {
        return this.dataService.updateSite(this.id, { intermittent_assets: value }, this);
    }
    get intermittentAssets() {
        return this._intermittentAssets;
    }
    set anomalousAssets(value) {
        console.error('Do not set objects this way');
    }
    setAnomalousAssets(value) {
        return this.dataService.updateSite(this.id, { anomalous_assets: value }, this);
    }
    get anomalousAssets() {
        return this._anomalousAssets;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateSite(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteSite(this.id, this);
    }
}
exports.default = Site;
//# sourceMappingURL=site.js.map